import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSignInWithEmailAndPassword } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import Loading from "../Shared/Loading";
import useToken from "../../Hooks/useToken";

const Login = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const [signInWithEmailAndPassword, user, loading, error] =
    useSignInWithEmailAndPassword(auth);
  const [token, tokenLoading] = useToken(user);

  const navigate = useNavigate();

  if (loading || tokenLoading) {
    return <Loading></Loading>;
  }

  let errorMessage;
  if (error) {
    errorMessage = <p className="text-error font-bold">{error?.message}</p>;
  }

  if (token) {
    navigate("/hello-gas/admin/dashboard");
  }

  const onSubmit = async (data) => {
    // console.log(data);
    signInWithEmailAndPassword(data.email, data.password);
  };

  return (
    <section className="mt-8 md:mt-0">
      <div className="h-screen flex justify-center items-center">
        <div className="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
          <div className="card-body">
            <h1 className="text-xl font-bold text-primary text-center">
              Login
            </h1>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-control mt-3">
                <label className="label">
                  <span className="label-text text-primary font-bold">
                    Email
                  </span>
                </label>

                <input
                  type="email"
                  placeholder="email"
                  className="input input-bordered text-primary"
                  {...register("email", {
                    required: {
                      value: true,
                      message: "Email is required.",
                    },
                  })}
                />
                <label className="label">
                  {errors.email?.type === "required" && (
                    <span className="label-text-alt font-bold text-error">
                      {errors.email.message}
                    </span>
                  )}
                </label>
              </div>
              <div className="form-control mt-3">
                <label className="label">
                  <span className="label-text text-primary font-bold">
                    Password
                  </span>
                </label>

                <input
                  type="password"
                  placeholder="password"
                  className="input input-bordered text-primary"
                  {...register("password", {
                    required: {
                      value: true,
                      message: "Password is required.",
                    },
                    minLength: {
                      value: 6,
                      message: "Password must have 6 character.",
                    },
                  })}
                />
                <label className="label">
                  {errors.password?.type === "required" && (
                    <span className="label-text-alt font-bold text-error">
                      {errors.password.message}
                    </span>
                  )}
                  {errors.password?.type === "minLength" && (
                    <span className="label-text-alt font-bold text-error">
                      {errors.password.message}
                    </span>
                  )}
                </label>

                <label className="label mt-3">
                  Create a new account click on
                  <Link
                    to="/hello-gas/admin/signup"
                    className="text-primary font-bold"
                  >
                    signup
                  </Link>
                </label>
              </div>
              {errorMessage}
              <div className="form-control mt-6">
                <button className="btn btn-primary">Login</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
